enum TaskPublishOutputQueue {
  ACTIVE = 'active',
  BACKLOG = 'backlog',
}

export default TaskPublishOutputQueue;
